/* Redesign-Navigation: Mega-Menü (Navigation-Kanon-1010 §3.4, U-95; Runde 2 11.10.: Messung rd_nav_click).
   Öffnet nach Verzögerung (Standard 300 ms, Baymard) bei Hover, sofort beim Wechsel zwischen offenen Punkten, per Knopf (Klick/Enter/Leertaste);
   schließt mit Verzögerung beim Verlassen, bei Esc (Fokus zurück auf den Knopf), Klick außerhalb und wenn der Fokus das Panel verlässt.
   Nutzt Sleeks Body-Klasse „has-dropdown-menu“ für die Abdunklung unter dem Kopf. */
(function () {
  function init() {
    var nav = document.querySelector('[data-rd-nav]');
    if (!nav || nav.dataset.rdInit) return;
    nav.dataset.rdInit = '1';
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-rd-mega]'));
    var delay = parseInt(nav.dataset.delay || '300', 10);
    var offen = null, tAuf = null, tZu = null;
    var fein = window.matchMedia('(hover: hover) and (pointer: fine)');

    function auf(it) {
      if (offen && offen !== it) zu(offen, true);
      var p = it.querySelector('.rd-mega');
      if (!p) return;
      p.hidden = false;
      it.classList.add('is-offen');
      var b = it.querySelector('.rd-nav__toggle');
      if (b) b.setAttribute('aria-expanded', 'true');
      document.body.classList.add('has-dropdown-menu');
      offen = it;
    }
    function zu(it, wechsel) {
      var p = it.querySelector('.rd-mega');
      if (p) p.hidden = true;
      it.classList.remove('is-offen');
      var b = it.querySelector('.rd-nav__toggle');
      if (b) b.setAttribute('aria-expanded', 'false');
      if (offen === it) offen = null;
      if (!wechsel) document.body.classList.remove('has-dropdown-menu');
    }

    items.forEach(function (it) {
      it.addEventListener('mouseenter', function () {
        if (!fein.matches) return;
        clearTimeout(tZu); clearTimeout(tAuf);
        tAuf = setTimeout(function () { auf(it); }, offen ? 0 : delay);
      });
      it.addEventListener('mouseleave', function () {
        if (!fein.matches) return;
        clearTimeout(tAuf);
        tZu = setTimeout(function () { if (offen === it) zu(it); }, delay);
      });
      var b = it.querySelector('.rd-nav__toggle');
      if (b) b.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(tAuf); clearTimeout(tZu);
        if (it.classList.contains('is-offen')) { zu(it); } else { auf(it); }
      });
      it.addEventListener('focusout', function (e) {
        if (offen === it && e.relatedTarget && !it.contains(e.relatedTarget)) zu(it);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && offen) {
        var b = offen.querySelector('.rd-nav__toggle');
        zu(offen);
        if (b) b.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (offen && !offen.contains(e.target)) zu(offen);
    });
  }
  /* Messung rd_nav_click (Navigation-Kanon §5, Runde 2 §7): Ort (leiste, mega, drawer, suche), Art (data-rd-nav-klick), Ziel.
     Nur Ereignis an dataLayer/Shopify-Analytics, keine eigene Speicherung. */
  function ort(el) {
    if (el.closest('.rd-mega')) return 'mega';
    if (el.closest('#MenuDrawer')) return 'drawer';
    if (el.closest('rd-suche')) return 'suche';
    if (el.closest('.rd-such-seite')) return 'suche-seite';
    if (el.closest('[data-rd-nav]')) return 'leiste';
    return 'sonst';
  }
  if (!window.rdNavKlick) {
    window.rdNavKlick = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-rd-nav-klick]');
      if (!a) return;
      var d = { ort: ort(a), art: a.getAttribute('data-rd-nav-klick'), ziel: a.getAttribute('href') || '', text: (a.textContent || '').trim().slice(0, 60) };
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'rd_nav_click', rd_nav: d }); } catch (x) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('rd_nav_click', d); } catch (x) {}
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
